import React from 'react';
import { useShowContext } from 'ui-builder';
import {
  IconButton,
  IconType,
  usePopupFormManager
} from 'features/nekst-widgets';
import {
  ProjectDocument,
  ProjectDocumentPermission,
} from 'nekst-api';
import { UploadDocumentForm } from 'features/tasks-forms';


export default function UploadDocumentButton() {
  const popupManager = usePopupFormManager();

  const showContext = useShowContext<ProjectDocument>();

  if (showContext.data!._permissions.includes(ProjectDocumentPermission.SET_FILE)) {
    return (
      <IconButton
        type={IconType.UPLOAD}
        onClick={() => {
          popupManager.openForm(<UploadDocumentForm data={showContext.data!} />);
        }}
        title="Upload Document"
      />
    );
  } else {
    return null;
  }
}
